import {ExtendedShiftQuickSelectSlots} from '@hconnect/common/types'
import {
  getTimeRangeOrQuickSelectSlotsString,
  getUrlParam,
  setOrDeleteStringParam
} from '@hconnect/common/utils'
import {useSearchParams} from 'react-router'

type Props<T extends ExtendedShiftQuickSelectSlots> = {
  key: string
  defaultSlot: T
}

export const useSlotParam = <T extends ExtendedShiftQuickSelectSlots>({
  key,
  defaultSlot
}: Props<T>) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const timeRangeParam = getUrlParam(searchParams, key)

  const setTimeRangeParam = (value: T) => {
    const timeRangeString = getTimeRangeOrQuickSelectSlotsString(value)
    const newParams = new URLSearchParams(searchParams)

    setOrDeleteStringParam(newParams, key, timeRangeString)
    setSearchParams(newParams)
  }

  return {
    slot: timeRangeParam ? (timeRangeParam as T) : defaultSlot,
    setTimeRange: setTimeRangeParam
  }
}
